import React from 'react';
import { TextInput } from '../../reusable-components/TextInput';

interface InvoiceDownloaderCaptchaFormProps {
  captchaImageBase64: string;
  captchaCode: string;
  loading: boolean;
  onCaptchaCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSendCaptcha: (e: React.FormEvent) => void;
}

export const InvoiceDownloaderCaptchaForm: React.FC<
  InvoiceDownloaderCaptchaFormProps
> = ({
  captchaImageBase64,
  captchaCode,
  loading,
  onCaptchaCodeChange,
  onSendCaptcha,
}) => {
  return (
    <div id="captcha" className="space-y-4">
      <img
        src={captchaImageBase64}
        alt="Captcha"
        className="border border-base-300 rounded"
      />
      <TextInput
        label="Captcha Code:"
        value={captchaCode}
        placeholder="Enter captcha code"
        custom_test_id="captcha-code-input"
        onChange={onCaptchaCodeChange}
        onEnterKeyPressed={(e) => {
          e.preventDefault();
          if (!loading) {
            onSendCaptcha({
              preventDefault: () => {
                console.debug('Sending captcha code... enter key pressed.');
              },
            } as React.FormEvent);
          }
        }}
        required={true}
        errorMessage="Captcha code is required"
        width="w-1/3"
      />
      <button
        type="button"
        className="btn btn-primary w-40"
        disabled={!captchaCode}
        onClick={onSendCaptcha}
      >
        Send Captcha
      </button>
    </div>
  );
};
